import { TopLeagueCompactMenuItem } from './partials/TopLeagueCompactMenuItem';
import './index.less';

export const TopLeagueCompactMenuItemWithWrapper = () => {
  return (
    <div className="compactViewWrapper">
      <TopLeagueCompactMenuItem />
    </div>
  );
};
